import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authApiService } from "./Apis/Auth";
import { bmifitnessApiService } from "./Apis/Calculator/BMI";
import { bmrfitnessApiService } from "./Apis/Calculator/BMR";
import { bodyfatfitnessApiService } from "./Apis/Calculator/BodyFat";
import { heartratefitnessApiService } from "./Apis/Calculator/HRC";
import { hydrationfitnessApiService } from "./Apis/Calculator/Hydration";
import { ibwfitnessApiService } from "./Apis/Calculator/IBW";
import { macrofitnessApiService } from "./Apis/Calculator/Macro";
import { onerepmaxfitnessApiService } from "./Apis/Calculator/ORM";
import { sleepfitnessApiService } from "./Apis/Calculator/Sleep";
import { whrfitnessApiService } from "./Apis/Calculator/WHR";
import { campaignApiService } from "./Apis/Campaign";
import { categoryApiService } from "./Apis/Category";
import { courseApiService } from "./Apis/Course";
import { dashboardApiService } from "./Apis/Dashboard";
import { digitalProductsApiService } from "./Apis/DigitalProducts";
import { discussionApiService } from "./Apis/Discussion";
import { faqApiService } from "./Apis/FAQ";
import { feedbackApiService } from "./Apis/Feedback";
import { balancefitnessApiService } from "./Apis/FitnessTest/Balance";
import { cardiofitnessApiService } from "./Apis/FitnessTest/Cardio";
import { flexibilityfitnessApiService } from "./Apis/FitnessTest/Flexibility";
import { strengthfitnessApiService } from "./Apis/FitnessTest/Strength";
import { funnelApiService } from "./Apis/Funnel";
import { generalApiService } from "./Apis/General";
import { generateCertificateApiService } from "./Apis/GenerateCertificate";
import { guidelineApiService } from "./Apis/Guideline";
import { guidelineactionApiService } from "./Apis/GuidelineAction";
import { homefeaturedcontrolApiService } from "./Apis/HomeFeaturedControl";
import { newsletterApiService } from "./Apis/Newsletter";
import { notificationApiService } from "./Apis/Notification";
import { packageApiService } from "./Apis/Packages";
import { plannerApiService } from "./Apis/Planner";
import { pressApiService } from "./Apis/Press";
import { profileOtherApiService } from "./Apis/ProfileOthers";
import { promotecourseApiService } from "./Apis/PromoteCourse";
import { pssApiService } from "./Apis/PSSWorkSpace";
import { quizApiService } from "./Apis/Quiz";
import { reviewApiService } from "./Apis/Review";
import { templateApiService } from "./Apis/Template";
import { userApiService } from "./Apis/User";
import rootReducer from "./Reducers";

//store
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PAUSE",
          "persist/FLUSH",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
      immutableCheck: false,
    }).concat(
      authApiService.middleware,
      generalApiService.middleware,
      courseApiService.middleware,
      digitalProductsApiService.middleware,
      categoryApiService.middleware,
      feedbackApiService.middleware,
      reviewApiService.middleware,
      userApiService.middleware,
      guidelineApiService.middleware,
      guidelineactionApiService.middleware,
      newsletterApiService.middleware,
      packageApiService.middleware,
      pressApiService.middleware,
      generateCertificateApiService.middleware,
      quizApiService.middleware,
      bmrfitnessApiService.middleware,
      bmifitnessApiService.middleware,
      bodyfatfitnessApiService.middleware,
      macrofitnessApiService.middleware,
      heartratefitnessApiService.middleware,
      ibwfitnessApiService.middleware,
      dashboardApiService.middleware,
      discussionApiService.middleware,
      profileOtherApiService.middleware,
      hydrationfitnessApiService.middleware,
      onerepmaxfitnessApiService.middleware,
      sleepfitnessApiService.middleware,
      whrfitnessApiService.middleware,
      balancefitnessApiService.middleware,
      cardiofitnessApiService.middleware,
      flexibilityfitnessApiService.middleware,
      strengthfitnessApiService.middleware,
      faqApiService.middleware,
      promotecourseApiService.middleware,
      campaignApiService.middleware,
      pssApiService.middleware,
      templateApiService.middleware,
      notificationApiService.middleware,
      plannerApiService.middleware,
      funnelApiService.middleware,
      homefeaturedcontrolApiService.middleware
    ),
});

export default store;
